import {
  ApiBlueprint,
  PageBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { Navigate } from 'react-router-dom';
import { environmentsApiRef } from './api/types';
import { EnvironmentsClient } from './api/EnvironmentsClient';
import { environmentsRouteRef } from './routes';

const environmentsApi = ApiBlueprint.make({
  name: 'environments',
  params: defineParams =>
    defineParams({
      api: environmentsApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new EnvironmentsClient({ discoveryApi, fetchApi }),
    }),
});

// noHeader because the page draws its own PluginHeader, which also owns the
// routed tabs.
const environmentSettingsPage = PageBlueprint.make({
  params: {
    path: '/environments',
    routeRef: environmentsRouteRef,
    noHeader: true,
    loader: () =>
      import('./components/EnvironmentSettingsPage').then(m => (
        <m.EnvironmentSettingsPage />
      )),
  },
});

// The flags page used to live at /env-feature-flags; keep bookmarks and Slack
// links working.
const legacyRedirectPage = PageBlueprint.make({
  name: 'legacy-redirect',
  params: {
    path: '/env-feature-flags',
    noHeader: true,
    loader: async () => <Navigate to="/environments/feature-flags" replace />,
  },
});

export const environmentsPlugin = createFrontendPlugin({
  pluginId: 'environments',
  routes: { root: environmentsRouteRef },
  extensions: [environmentsApi, environmentSettingsPage, legacyRedirectPage],
});
